'use client'
import { listUsers } from "@/app/api";
import { Table, TableRow, TableHeader, TableCell, SmartLink, ColorButton, Pagination } from "@/components/ui";
import { UserSearchParams, UsersResponse } from "@/types";
import React, { useEffect, useState } from "react";

export function AccountantTable() {
    const [accountantData, setAccountantData] = useState<UsersResponse>()
    const [filters, setFilters] = useState<UserSearchParams>({
        page: 1,
        perPage: 10,
        order: "desc",
        orderBy: "createdAt",
        userType: "accountant"
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await listUsers(filters)
                setAccountantData(data)
            } catch (err) {
                console.log("Erro ao carregar usuários: ", err);
            }
        }

        fetchUsers()
    }, [filters]);

    const accountants = accountantData?.data || []

    const handlePageChange = (page: number) => {
        setFilters({ ...filters, page });
    };

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>Data do cadastro</TableHeader>
                            <TableHeader>Selecionar Contador</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        {accountants.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} className="text-center">
                                    Não existem contadores.
                                </TableCell>
                            </TableRow>
                        ) : (accountants.map((accountant) => (
                            <React.Fragment key={accountant.id}>
                                <TableRow>
                                    <TableCell>{accountant.code}</TableCell>
                                    <TableCell>{accountant.userName}</TableCell>
                                    <TableCell>{accountant.name}</TableCell>
                                    <TableCell>{accountant.email}</TableCell>
                                    <TableCell>{new Date(accountant.createdAt).toLocaleDateString()}</TableCell>
                                    <TableCell>
                                        <SmartLink type={"internal"} route={"adminAccountantIdClients"}
                                            params={[accountant.id]}>
                                            <ColorButton>
                                                Ver Clientes
                                            </ColorButton>
                                        </SmartLink>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableHeader colSpan={2}>Observação</TableHeader>
                                    <TableCell colSpan={3}>{accountant.observation}</TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))
                        )
                        }
                    </tbody>

                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        {accountants.length === 0 ? (
                            <TableRow>
                                <TableCell className="text-center">
                                    Não existem contadores.
                                </TableCell>
                            </TableRow>
                        ) : (accountants.map((accountant) => (
                            <TableRow key={accountant.id}>
                                <TableHeader>Código</TableHeader>
                                <TableCell>{accountant.code}</TableCell>
                                <TableHeader>Empresa</TableHeader>
                                <TableCell>{accountant.userName}</TableCell>
                                <TableHeader>Nome</TableHeader>
                                <TableCell>{accountant.name}</TableCell>
                                <TableHeader>Email</TableHeader>
                                <TableCell>{accountant.email}</TableCell>
                                <TableHeader>Data do cadastro</TableHeader>
                                <TableCell>{new Date(accountant.createdAt).toLocaleDateString()}</TableCell>
                                <TableHeader>Observação</TableHeader>
                                <TableCell>{accountant.observation}</TableCell>
                                <TableHeader>Selecionar Contador</TableHeader>
                                <TableCell>
                                    <SmartLink type={"internal"} route={"adminAccountantIdClients"}
                                        params={[accountant.id]}>
                                        <ColorButton>
                                            Ver Clientes
                                        </ColorButton>
                                    </SmartLink>
                                </TableCell>
                                <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                            </TableRow>
                        ))
                        )
                        }
                    </tbody>
                </Table>
            </div>

            <div>
                {accountantData?.pagination &&
                    <Pagination
                        currentPage={accountantData.pagination.page}
                        totalPages={Math.ceil(accountantData.pagination.total / accountantData.pagination.perPage)}
                        onPageChange={handlePageChange}
                    />
                }
            </div>
        </div>
    )
}